import { AxiosInstance } from "axios"
import { BillReceiver } from "./receiptConfirmOrderDialogTypes"

export enum ReceiptConfirmOrderDialogQuery {
    BILL_RECEIVER = "bill-receiver-item",
}

type BillReceiversParams = Readonly<{
    userId: number
    receiverId: number
}>
export type BillReceiverResponse = Readonly<{
    billReceiver: BillReceiver
}>

export async function fetchBillReceiver(
    { userId, receiverId }: BillReceiversParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<BillReceiverResponse> {
    const url = `/users/${userId}/payment/billReceivers/${receiverId}`
    const { data } = await axios.get(url, {
        signal,
    })

    return data
}
